import { render, staticRenderFns } from "./detalleAprobadorLibrosObsequios.vue?vue&type=template&id=5b7bed17"
import script from "./detalleAprobadorLibrosObsequios.vue?vue&type=script&lang=js"
export * from "./detalleAprobadorLibrosObsequios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports